import React, { Component } from "react";
import { FeedSourceRequests, getLanguages } from "../../../utils";
import { createAlert, FeedSourceRequestsActions, UtilActions } from "../../../actions";
import ElementEditCard from "../../molecules/ElementEditCard";
import { history } from "../../../utils/store";

interface IEditFeedSourceRequestsProps {}
interface IEditFeedSourceRequestsState {
    _id: string;
    countries: Array<{ code: string; name: string }>;
}

export default class EditFeedSourceRequests extends Component<IEditFeedSourceRequestsProps, IEditFeedSourceRequestsState> {
    static allowSuper = true;
    static allowApiAdmin = true;
    static allowClientAdmin = true;
    static allowAdmin = false;
    static allowCurator = false;
    static allowReports = false;

    constructor(props) {
        super(props);

        let _id = "";
        if (props.match.params._id) {
            _id = props.match.params._id;
        }

        this.state = { _id, countries: [] };
    }

    componentDidMount() {
        this.loadCountries();
    }

    async loadCountries() {
        this.setState({ countries: await UtilActions.doGetCountries() });
    }

    async _onSubmit(item: Mongo.FeedSourceRequests & { _id?: string }) {
        if (item._id === "") {
            delete item._id;
        }

        if (item.region) {
            item.region = Number(item.region);
        }


        Object.keys(item).forEach(key => {
            if (item[key] == "") {
                item[key] = null;
            }
        });
        if (!item.url) {
            createAlert("Invalid url", "error");
            return;
        }

        let validation = { valid: true }

        let proceed = true;
        if (validation && ("valid" in validation && !validation.valid)) {
            proceed = confirm(
                `We cannot validate the ${item.type === "SM" ? "Site Map" : item.type}. Would you like to proceed?`
            );
        }

        if (proceed) {
            try {
                if(!item.weight){
                    item.weight = 0.5
                }


                await FeedSourceRequestsActions.doUpsert(item);

                if (item._id) {
                    createAlert(`Successfully updated`, `success`);
                } else {
                    createAlert(`Successfully created feed source request`, "success");
                }
                setTimeout(() => {
                    history.push("/feeds-requests");
                }, 0);
            } catch (err) {
                //
            }
        }
    }

    render() {
        const { _id, countries } = this.state;
        return (
            <ElementEditCard<Mongo.FeedSourceRequests & { _id?: string }>
                getItem={async () => ({
                    ...FeedSourceRequests({ _id, ...(_id != "" ? { ...(await FeedSourceRequestsActions.doGet(_id)) } : { weight: 0.5 }) })
                })}
                canUpdate={() => Promise.resolve(true)}
                update={item => this._onSubmit(item)}
                breadcrumbs={[{ name: "Feed Source Requests", link: "/feeds-requests" }]}
                elementName="Feed Source Request"
                idField="_id"
                isInsert={item => !!(item && item._id == "")}
                editableKeys={item => {
                    return {
                        type: {
                            label: "Type",
                            type: "select",
                            values: [{ label: "RSS", value: "RSS" }, { label: "SiteMap", value: "SiteMap" }]
                        },
                        language: {
                            label: "Language",
                            type: "select",
                            values: getLanguages().map(lang => ({ label: lang.name, value: lang.name }))
                        },
                        location: {
                            label: "Location",
                            type: "select",
                            values: [
                                { value: "", label: "NONE" },
                                ...countries.map(locations => ({
                                    label: locations.name,
                                    value: locations.name
                                }))
                            ]
                        },
                        region: {
                            label: "Region",
                            type: "select",
                            values: [
                                { value: "-2", label: "NONE" },
                                { value: "1", label: "Australia & NZ" },
                                { value: "2", label: "Far East" },
                                { value: "3", label: "India" },
                                { value: "4", label: "Middle East & Africa" },
                                { value: "5", label: "Europe" },
                                { value: "6", label: "South America" },
                                { value: "7", label: "East - North America" },
                                { value: "8", label: "Central - North America" },
                                { value: "9", label: "West - North America" },
                                { value: "-1", label: "Other" }
                            ]
                        },
                        url: {
                            label: "URL",
                            type: "text",
                            fullWidth: false
                        },
                        weight: {
                            label: "Weight",
                            type: "select",
                            values: [
                                { value: 0.1, label: "0.10" },
                                { value: 0.2, label: "0.20" },
                                { value: 0.3, label: "0.30" },
                                { value: 0.4, label: "0.40" },
                                { value: 0.5, label: "0.50" },
                                { value: 0.6, label: "0.60" },
                                { value: 0.7, label: "0.70" },
                                { value: 0.8, label: "0.80" },
                                { value: 0.9, label: "0.90" },
                                { value: 1.0, label: "1.00" }
                            ]
                        },
                        category: {
                            label: "Category",
                            type: "select",
                            values: [
                                { label: "Arts Entertainment", value: "Arts Entertainment" },
                                { label: "Business", value: "Business" },
                                { label: "Computer Internet", value: "Computer Internet" },
                                { label: "Health", value: "Health" },
                                { label: "Law", value: "Law" },
                                { label: "Lifestyle", value: "Lifestyle" },
                                { label: "Marketing", value: "Marketing" },
                                { label: "News Media", value: "News Media" },
                                { label: "Politics", value: "Politics" },
                                { label: "Recreation Sports", value: "Recreation Sports" },
                                { label: "Science Technology", value: "Science Technology" },
                                { label: "Society Culture", value: "Society Culture" }
                            ]
                        }
                    };
                }}
            />
        );
    }
}
